/**
 * Show app icons base on user's permission level (roleId).
 */
import React, { Component } from 'react';

import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import {
  ADMIN_ID,
  DOCTOR_ID,
  NURSE_ID,
  DIETITIAN_ID,
  PHARMACIST_ID,
  PATIENT_ID,
  ASSISTANT_ID,
} from '../../constants/RoleConstants';
import i18n from '../../config/i18n';

// SVG icons
import patientIcon from '../../styles/dashboard-icons/patient.svg';
import profileIcon from '../../styles/dashboard-icons/profile.svg';
import metadataIcon from '../../styles/dashboard-icons/metadata.svg';
import recordIcon from '../../styles/dashboard-icons/record.svg';
import teamIcon from '../../styles/dashboard-icons/team.svg';
import activityLogIcon from '../../styles/dashboard-icons/activity-log.svg';
import testimonialIcon from '../../styles/dashboard-icons/testimonial.svg';
import messagingIcon from '../../styles/dashboard-icons/messaging.svg';
// import fileIcon from '../../styles/dashboard-icons/file.svg';
import exerciseIcon from '../../styles/dashboard-icons/exercise.svg';
import presentIcon from '../../styles/dashboard-icons/present.svg'; // downloaded from googling

const EVERYONE = [
  ADMIN_ID,
  DOCTOR_ID,
  ASSISTANT_ID,
  NURSE_ID,
  DIETITIAN_ID,
  PHARMACIST_ID,
  PATIENT_ID,
];

class DashboardContainer extends Component {
  navigate(link) {
    this.props.router.navigate(link, { trigger: true });
  }

  renderIcon(icon, roleId) {
    if (icon.permissions.indexOf(roleId) === -1) {
      return null;
    }
    return (
      <a
        key={icon.link}
        className="col-md-3 app-icon-container"
        onClick={(e) => {
          e.preventDefault();
          this.navigate(icon.link);
        }}
      >
        <div className={`app-icon-base gradient-${icon.color}`}>
          <img className="app-icon" src={icon.img} alt={icon.label} width="65" />
        </div>
        <div className="app-icon-label">{icon.label}</div>
      </a>
    );
  }

  render() {
    const allIcons = [
      {
        label: i18n.t('managePatients'),
        link: '/medical-records',
        color: 'light-blue',
        img: patientIcon,
        permissions: [DOCTOR_ID, ASSISTANT_ID, NURSE_ID, DIETITIAN_ID, PHARMACIST_ID],
      },
      {
        label: i18n.t('myProfile'),
        link: '/profile',
        color: 'blue',
        img: profileIcon,
        permissions: EVERYONE,
      },
      {
        label: i18n.t('metadata'),
        link: '/metadata',
        color: 'red',
        img: metadataIcon,
        permissions: [ADMIN_ID],
      },
      {
        label: i18n.t('medicalRecords'),
        link: '/records',
        color: 'green',
        img: recordIcon,
        permissions: [PATIENT_ID],
      },
      {
        label: i18n.t('team_Invitations'),
        link: '/team',
        color: 'green',
        img: teamIcon,
        permissions: [ADMIN_ID, DOCTOR_ID],
      },
      {
        label: i18n.t('activityLogs'),
        link: '/activity-logs',
        color: 'orange',
        img: activityLogIcon,
        permissions: EVERYONE,
      },
      {
        label: i18n.t('testimonials'),
        link: '/admin-testimonials',
        color: 'red',
        img: testimonialIcon,
        permissions: [ADMIN_ID],
      },
      {
        label: i18n.t('messaging'),
        link: '/messaging',
        color: 'green',
        img: messagingIcon,
        permissions: EVERYONE,
      },
      // TODO: temporary disabled, we are going to clean fileUpload module up on next PR
      // {
      //   label: i18n.t('fileUpload'),
      //   link: '/file',
      //   color: 'red',
      //   img: fileIcon,
      //   permissions: [DOCTOR_ID, NURSE_ID, DIETITIAN_ID, PHARMACIST_ID],
      // },
      {
        label: i18n.t('exercise'),
        link: '/fpp/exercise',
        color: 'light-blue',
        img: exerciseIcon,
        permissions: EVERYONE,
      },
      {
        label: i18n.t(['dashboard', 'subscription']),
        link: '/subscription',
        color: 'light-blue',
        img: presentIcon,
        permissions: [DOCTOR_ID, ASSISTANT_ID, NURSE_ID, DIETITIAN_ID, PHARMACIST_ID],
      },
    ];
    const { roleId } = this.props.reducers.user.profile;

    return (
      <div className="DashboardContainer">
        <div className="container-fluid">
          <div className="row">
            {
              allIcons.map(icon => this.renderIcon(icon, roleId))
            }
          </div>
        </div>
      </div>
    );
  }
}

export default connectActionsAndReducers(DashboardContainer);



// WEBPACK FOOTER //
// ./src/containers/dashboard/DashboardContainer.js